export default __webpack_public_path__ + "static/media/member_default.3761880a.png";